import {
  UserIcon,
  UploadIcon,
  InvoiceIcon,
  FolderIcon,
  StarIcon
} from '../components/Icon';

type ModulesType = {
  name: string;
  description?: string;
  icon: any;
  comingSoon?: boolean;
  action?: string;
  extraClasses?: string;
}


export const MODULES_LIST: ModulesType[] = [
  {
    name: 'Invoicing',
    description: 'Add, edit, and manage your invoices at one place',
    icon: <i className="las la-file-invoice"></i>,
    action: 'redirectToInvoiceList'
  },
  {
    name: 'Invoicing (Advanced)',
    description: 'Add, edit, and manage your invoices at one place',
    icon: <i className="las la-file-invoice"></i>,
    action: 'redirectToInvoiceGeneration'
  },
  {
    name: 'File Manager',
    description: 'Upload, download or view your documents and manage your files',
    icon: <i className="las la-folder-open"></i>,
    action: 'redirectToUploadDocument'
  },
  {
    name: 'Job tracker',
    description: 'All your jobs at one place. Track, view or know the status.',
    icon: <i className="las la-business-time"></i>,
    action: 'redirectToJobTracker'
  },
  // {
  //   name: 'Insights',
  //   description: 'Get real-time insights of all the important data you need',
  //   icon: <i className="lar la-chart-bar"></i>,
  //   action: 'redirectToInsights'
  //   // comingSoon: true,
  // },
  {
    name: 'Insights',
    description: 'All your necessary business insights are here',
    icon: <i className="las la-book-open"></i>,
    action: 'redirectToInsightsAdvanced'
    // comingSoon: true,
  },
  {
    name: 'Open Items',
    description: 'Track document status of your open jobs, add comments, and upload required docs',
    icon: <i className="las la-box-open"></i>,
    action: 'redirectToOpenItems'
    // comingSoon: true
  },
  {
    name: 'Reports',
    description: 'Get all your reports and statements here.',
    icon: <i className="las la-stream"></i>,
    action: 'redirectToReports'
  },
  {
    name: 'Settings',
    description: 'Manage all your settings here.',
    icon: <i className="las la-cog"></i>,
    action: 'redirectToClientSettings'
    // comingSoon: true
  },
  {
    name: 'Client Id Password Manager',
    description: 'Manage all your Id Password here.',
    icon: <i className="las la-key"></i>,
    action: 'redirectToClientIdPasswordManager'
    // comingSoon: true
  },
  {
    name: 'Portfolio Management',
    description: '',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Subscription',
    description: 'Manage your payments and other subscriptions at a single place',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Contact Management',
    description: 'Manage your All Contact From a single place',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Sales and Purchases',
    description: 'Manage your All Sales and Purchases at a single place',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Inventory and Warehouses',
    description: 'Inventory and Warehouses information from here',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Expense Reporting and Reimbursements',
    description: 'Track Your Expense Reporting and Reimbursements',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Manage Subscriptions- MRR/ARPU/LTV',
    description: 'Manage Your Subscriptions of MRR/ARPU/LTV',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Accounting and Online Payments',
    description: 'Manage your Accounting and Online Payments from here',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Tax Compliant - VAT/GST/Sales Tax',
    description: 'Track Your Tax Compliant Details(VAT/GST/Sales Tax)',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'One-time and Recurring Payment Pages',
    description: 'This is One-time and Recurring Payment Pages',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Payroll and Tax Reports',
    description: 'All about Payroll and Tax Reports',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Employee Profile and Benefits Management',
    description: 'Manage your Employee Profile and Benefits Management at a single place',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Statutory Compliance - PF/ESI/PT/LWF/IT',
    description: 'All Statutory Compliance Details(PF/ESI/PT/LWF/IT)',
    icon: <StarIcon />,
    comingSoon: true
  },
  {
    name: 'Salary Payments',
    description: 'Manage your Salary Payments at a single place',
    icon: <StarIcon />,
    comingSoon: true
  },
];

// export const ADMIN_REPORT_MODULES: ModulesType[] = [
//   {
//     name: 'Job Progress',
//     description: 'Track all open jobs progress at a single place.',
//     icon: <i className="las la-business-time"></i>,
//     action: 'redirectToJobProgress'
//   },
//   {
//     name: 'Open Items Progress',
//     description: `What's the status of open items? Track here.`,
//     icon: <i className="las la-box-open"></i>,
//     action: 'redirectToAllOpenItems'
//   },
//   {
//     name: 'File And Folder Count Reports',
//     description: `All file and folder counter are here`,
//     icon: <i className="las la-folder-open"></i>,
//     action: 'redirectToFileFolderCount'
//   },
//   {
//     name: 'Assigned Users Of Single Client',
//     description: `All assigned users of single client`,
//     icon: <i className="las la-user-minus"></i>,
//     action: 'redirectToAssignedUsersOfClient'
//   },
//   {
//     name: 'Invoicing Count',
//     description: `What's the Count of Invoicing Advance`,
//     icon: <i className="las la-file-invoice"></i>,
//     action: 'redirectToInvoicingCount'
//   }
// ];

export const CLIENT_SETTING_MODULES: ModulesType[] = [
  {
    name: 'Address Manager',
    description: `Add/Edit all your business addresses here`,
    icon: <i className="las la-folder-open"></i>,
    action: 'redirectToAddresses'
  },
  {
    name: 'Customers/Suppliers',
    description: `Add/Edit and manage your customers and suppliers here`,
    icon: <i className="las la-shipping-fast"></i>,
    action: 'redirectToSuppliers'
  },
  {
    name: 'Accounts Manager',
    description: `Add/Edit and manage all of your accounts here`,
    action: 'redirectToAccountsManager',
    icon: <i className="las la-file-invoice-dollar"></i>
  },
  {
    name: 'Stock Manager',
    description: `Add/Edit and manage all of your stock units here`,
    action: 'redirectToStockManager',
    // comingSoon: true,
    icon: <i className="las la-truck-loading"></i>,
    // comingSoon: true
  },
];

export const STOCK_MANAGER_MODULES: ModulesType[] = [
  {
    name: 'Stock Groups',
    description: `Add/Edit all your stock groups here`,
    icon: <i className="las la-boxes"></i>,
    action: 'redirectToStockGroups'
  },
  {
    name: 'Stock Items',
    description: `Add/Edit all your stock items here`,
    icon: <i className="las la-dolly-flatbed"></i>,
    action: 'redirectToStockItems'
  },
  {
    name: 'Units of Measurement',
    description: `Add/Edit all your measuring units here`,
    icon: <i className="las la-balance-scale-left"></i>,
    action: 'redirectToUnitsOfMeasurement'
  },
];

export const USER_MANAGEMENT_MODULES: ModulesType[] = [
  {
    name: 'User Groups',
    description: `Add/Edit user groups`,
    icon: <i className="las la-balance-scale-left"></i>,
    action: 'redirectToUserGroups'
  },
  {
    name: 'Assign User Groups to Users',
    description: `Assign menus to users`,
    icon: <i className="las la-balance-scale-left"></i>,
    action: 'redirectToAssignMenuGroup'
  },
  {
    name: 'Menu List',
    description: `Add/Edit menus`,
    icon: <i className="las la-balance-scale-left"></i>,
    action: 'redirectToMenuList'
  },
]